/**
 * Javascript file for the notification component.
 * @author Eduardo Parducci
 */

import {eventEmitter} from "../../../api.js";
import auth from "../../../auth.js";

export default {
  name: "Notification",

  /**
   * The vue instance's data object.
   * @property {string} snackbar.message - The notifications message.
   * @property {number} snackbar.duration - How long the notification will stay on screen.   
   * @property {boolean} snackbar.isInfinity - Determines if the notification is persistent on screen.
   * @property {boolean} snackbar.visible - Controlls the notifications visibility.
   */
  data() {
    return {
      snackbar: {
        message: "",
        duration: 3000, // Default timeout for non-error notifications
        isInfinity: false,
        visible: false
      }
    }
  },
  /**
   * Called after the instance is mounted.
   * Watch auth.js and api.js event emitters (API calls) to react and open the notification box
   * whenever necessary
   */  
  mounted() {
    let self = this; // 'this' is not visible inside event handler function
    // watch api.js emitter 
    eventEmitter.on('Notification', function (notification) {
      console.log('Got notification!');
      self.snackbar.visible = true;
      self.snackbar.message = notification.msg;
      self.snackbar.isInfinity = notification.isError;
      self.snackbar.visible = true;
    });
    // watch auth.js emitter
    auth.eventEmitter.on('Notification', function (notification) {
      self.snackbar.visible = true;
      self.snackbar.message = notification.msg;
      self.snackbar.isInfinity = notification.isError;
      self.snackbar.visible = true;
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/app/notification/notification.js